import React from 'react';
import { DATE_FORMAT } from '../pages/Extranet/PayoutList/PayoutList';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AlertTitle from '@material-ui/lab/AlertTitle';
import format from 'date-fns/format';
import Button from '@material-ui/core/Button';

interface UnclaimedPayoutMessageProps {
    amount: string;
    periodFrom: Date;
    periodTo: Date;
    action?: () => void;
}

export const UnclaimedPayoutMessage = ({
    amount,
    periodFrom,
    periodTo,
    action,
}: UnclaimedPayoutMessageProps): JSX.Element => (
    <Box mb={2}>
        <Alert severity={'warning'}>
            <AlertTitle>Unclaimed payout</AlertTitle>
            <Typography>
                You have an unclaimed payout for your app sales in the Bókun Developer Partner
                program. The total sum of your sales revenue is <strong>{amount}</strong> for the
                period between <strong>{format(periodFrom, DATE_FORMAT)}</strong> and{' '}
                <strong>{format(periodTo, DATE_FORMAT)}</strong>
            </Typography>
            {action && (
                <Box mt={2} display={'flex'} justifyContent={'flex-end'}>
                    <Button variant={'contained'} color="primary" onClick={action}>
                        Claim payout
                    </Button>
                </Box>
            )}
        </Alert>
    </Box>
);
